import React from 'react';
import { ActionServiceV2 } from '@/containers/ActionServiceV2';
import { useCustomerJourney } from '../../context/setup';
import { useAuth } from '@/contexts';

export const FirstServiceStep: React.FC = () => {
  const { state } = useCustomerJourney();
  const { session } = useAuth();
  const [isServiceCreated, setIsServiceCreated] = React.useState(false);

  // Monitorear cuando se cree el primer servicio para mostrar loading
  React.useEffect(() => {
    const checkServiceCreation = () => {
      const serviceCreatedFlag = localStorage.getItem('cj_service_created_waiting');
      if (serviceCreatedFlag === 'true') {
        setIsServiceCreated(true);
      }
    };

    checkServiceCreation();
    // Verificar cada segundo si el flag está activo
    const interval = setInterval(checkServiceCreation, 1000);

    return () => clearInterval(interval);
  }, []);

  // Limpiar el loading cuando first_service_at se actualice
  React.useEffect(() => {
    if (isServiceCreated && session?.vendor?.vendor_activity_tracking?.first_service_at) {
      setIsServiceCreated(false);
      localStorage.removeItem('cj_service_created_waiting');
    }
  }, [isServiceCreated, session?.vendor?.vendor_activity_tracking?.first_service_at]);

  // Limpiar el flag cuando se complete el step
  React.useEffect(() => {
    // Si ya se completó este step, limpiar el flag
    if (state.stepsCompleted[4]) {
      // StepType.FIRST_SERVICE = 4
      localStorage.removeItem('cj_first_service_creation_mode');
      localStorage.removeItem('cj_service_created_waiting');
    }
  }, [state.stepsCompleted]);

  // Mostrar spinner si el servicio fue creado pero aún no se actualizó la sesión
  if (isServiceCreated) {
    return (
      <div className="mb-4 flex flex-col items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue mb-4"></div>
        <p className="text-gray-600 text-center">Procesando tu primer servicio...</p>
        <p className="text-gray-500 text-sm text-center mt-2">Esto puede tomar unos segundos</p>
      </div>
    );
  }

  return (
    <div className="mb-4 max-[600px]:max-w-[calc(100vw-60px)]">
      <ActionServiceV2 />
    </div>
  );
};
